export const environment = {
  production: false,
  envString: 'staging',
  APIURL: 'https://asan-jobs-office-api-server-staging-982203785653.us-east4.run.app',
};
